module.exports = __webpack_public_path__ + "img/EyeIcon.e18d47d2.svg";